<template>
  <div class='UserRegister'>
    <div class="cont-btn">
      <button v-if="$route.path !== '/painel/user/edit'" @click="push">Adicionar</button>
      <button v-if="$route.path === '/painel/user/edit'" @click="update">Atualizar</button>
    </div>
    <div class="cont-form">
      <div class="block-left">
        <input-reg
        text="Usuário(Mínimo 4 caracteres)"
        :value="SelectedUserEdit.usuario"
        @update:modelValue="newValue => ChangeUserEdit({ usuario: newValue })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '5px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', borderRadius: '5px' }"
        :error="UserValidate.usuario.$invalid"
        :errorMsg="UserValidate.usuario.has.$invalid ? UserValidate.usuario.has.$message : ''"
        v-if="$route.path !== '/painel/user/edit'"
        />
        <input-reg
        text="Nome"
        :value="SelectedUserEdit.nome"
        @update:modelValue="newValue => ChangeUserEdit({ nome: newValue })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', borderRadius: '5px' }"
        :error="UserValidate.nome.$invalid"
        />
        <input-reg
        text="Sobrenome"
        :value="SelectedUserEdit.sobrenome"
        @update:modelValue="newValue => ChangeUserEdit({ sobrenome: newValue })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', borderRadius: '5px' }"
        :error="UserValidate.sobrenome.$invalid"
        />
        <input-reg
        text="Email"
        :value="SelectedUserEdit.email"
        @update:modelValue="newValue => ChangeUserEdit({ email: newValue })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', borderRadius: '5px' }"
        :error="UserValidate.email.$invalid"
        :errorMsg="UserValidate.email.has.$invalid ? UserValidate.email.has.$message : ''"
        v-if="$route.path !== '/painel/user/edit'"
        />
        <input-reg
        text="Senha(Mínimo 6 caracteres)"
        type="password"
        :value="SelectedUserEdit.senha"
        @update:modelValue="newValue => ChangeUserEdit({ senha: newValue })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', borderRadius: '5px' }"
        :error="UserValidate.senha.$invalid"
        />
        <input-reg
        text="Confirmar senha"
        type="password"
        :value="SelectedUserEdit.csenha"
        @update:modelValue="newValue => ChangeUserEdit({ csenha: newValue })"
        :cont="{ width: '100%', textAlign: 'left' }"
        :label="{ marginLeft: '3px', marginTop: '10px' }"
        :input="{ fontSize: '26px', padding: '1.5%', width: '97%', borderRadius: '5px' }"
        :error="UserValidate.csenha.$invalid"
        />
      </div>
      <div class="block-right">
        <user-permission/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import InputReg from '../Produtos/Register/InputReg.vue';
import UserPermission from './Register/UserPermission'
import { useVuelidate } from '@vuelidate/core'
import { required, email, minLength, helpers } from '@vuelidate/validators'
export default {
  setup () {
    return { v$: useVuelidate() }
  },
  name: 'UserRegister',
  components: { UserPermission, InputReg },
  computed: {
    ...mapGetters(['SelectedUserEdit', 'UserValidate']),
    usuario () {
      return this.SelectedUserEdit.usuario
    },
    email () {
      return this.SelectedUserEdit.email
    },
    nome () {
      return this.SelectedUserEdit.nome
    },
    sobrenome () {
      return this.SelectedUserEdit.sobrenome
    },
    senha () {
      return this.SelectedUserEdit.senha
    },
    csenha () {
      return this.SelectedUserEdit.csenha
    }
  },
  methods: {
    ...mapActions(['ChangeUserEdit', 'PushUser', 'PushMsg', '_UpdateUser', 'VerifyUserEmailHas', 'setUserValidate']),
    async push () {
      let valid = await this.v$.$validate()
      this.setUserValidate(this.v$)
      if(!valid) {
        return
      }
      this.PushUser(this.SelectedUserEdit)
    },
    async update () {
      if(this.v$.nome.$invalid || this.v$.sobrenome.$invalid || this.v$.senha.$invalid || this.v$.csenha.$invalid) {
        this.setUserValidate(this.v$)
        return
      }
      this._UpdateUser(this.SelectedUserEdit)
    },
    async userHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.user) },
    async emailHas (str) { return await this.VerifyUserEmailHas({ user: str, email: str }).then(res => res.email) }
  },
  validations () {
    return {
      usuario: {
        required,
        minLength: minLength(4),
        has: helpers.withMessage('Nome de usuário não disponível', helpers.withAsync(this.userHas))
      },
      email: {
        required,
        email,
        has: helpers.withMessage('Email não disponível', helpers.withAsync(this.emailHas))
      },
      nome: {
        required
      },
      sobrenome: {
        required
      },
      senha: {
        required,
        minLength: minLength(6)
      },
      csenha: {
        required,
        minLength: minLength(6),
        sameAs: (s) => s === this.senha
      }
    }
  }
}
</script>

<style scoped>
.UserRegister {
  width: 98%;
  height: 95%;
  padding: 1%;
  overflow: auto;
}

.cont-form {
  display: flex;
}

.block-left {
  width: 50%;
  padding: 1%;
}

.block-right {
  width: 50%;
  padding: 1%;
}

.cont-btn {
  padding-bottom: 1%;
  text-align: right;
}

button {
  border: 0;
  font-size: 18px;
  padding: 1%;
  background-color: #000000;
  color: #FFFFFF;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 2%
}

@media (max-width: 500px) {
  .UserRegister {
    height: 75%;
  }
  .cont-form {
    display: block;
  }
  .block-left {
    width: 98%;
  }
  .block-right {
    width: 98%;
  }
}
</style>
